import workspaceQuery from '../../../graphql/queries/product/SellingPriceMatrixPreviewWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/PriceMatrixPreviewQuery.graphql';
import fragment from '../../../graphql/fragments/product/AbstractPriceMatrixPreviewFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ProductPriceMatrixPreview: EntityType = {
  type: 'PriceChange',
  title: 'Product Price Matrix Preview',
  workspaceUrl: '/Sales/CustomerPricing/ProductPriceMatrix/Preview/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'PRODUCT_PRICE_MATRICES',
};

export default ProductPriceMatrixPreview;
